export const SLIDING_ANIMATION_DURATION = 200;
export const HEADER_HEIGHT = 60;
export const PRIMARY_SHADE_WHITE = 6;
export const PRIMARY_SHADE_DARK = 6;
export const CONVERSATION_VIEW_MAW = '48rem';
export const MAX_WIDTH = 1600;
export const CARD_WIDTH = 260;
export const CARD_HEIGHT = 135;
